import { createSelector } from 'reselect';

import getModels from '@/state/selectors/navigation/get-models.ts';
import {
	PrimaryPageModel,
	RootModel,
} from '@/state/slices/navigation/typings.ts';
import { PageModel } from '@adobe/aem-react-editable-components';

const getLocale = createSelector([getModels], (models) => {
	if (!models) return null;

	const primaryModel: PageModel = Object.values(models).find(
		(m: PageModel) => (m as PrimaryPageModel).isPrimary,
	) as PrimaryPageModel;
	if (!primaryModel) {
		return null;
	}

	const rootItem: RootModel | undefined = primaryModel[':items']?.[
		primaryModel[':itemsOrder']![0]
	] as RootModel;

	return rootItem?.[':items']?.navmenu?.locale;
});

export default getLocale;
